import { CommonModule, DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { NgChartsModule } from 'ng2-charts';
import { CustomTranslateService } from '../services/translate/custom-translate.service';
import { AlertComponent } from './components/alert/alert.component';
import { BankCardComponent } from './components/bank-card/bank-card.component';
import { CreditCardComponent } from './components/bank-card/credit-card/credit-card.component';
import { ButtonComponent } from './components/button/button.component';
import { CardComponent } from './components/card/card.component';
import { CarouselComponent } from './components/carousel/carousel.component';
import { ChallengeResponseModalComponent } from './components/challenge-response-modal/challenge-response-modal.component';
import { FilterTransactionsComponent } from './components/filter-transactions/filter-transactions.component';
import { FormFieldErrorComponent } from './components/form-field-error/form-field-error.component';
import { LineChartComponent } from './components/line-chart/line-chart.component';
import { MessageItemComponent } from './components/message-item/message-item.component';
import { ModalComponent } from './components/modal/modal.component';
import { PageLinkComponent } from './components/page-link/page-link.component';
import { ProfileItemComponent } from './components/profile-item/profile-item.component';
import { ProgressComponent } from './components/progress/progress.component';
import { SidebarHeaderComponent } from './components/sidebar-header/sidebar-header.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { CardDropdownComponent } from './components/standard-account/card-dropdown/card-dropdown.component';
import { StandardAccountComponent } from './components/standard-account/standard-account.component';
import { TitleArrowsComponent } from './components/title-arrows/title-arrows.component';
import { TransactionItemComponent } from './components/transaction-item/transaction-item.component';
import { AccountBalanceDirective } from './directives/account-balance.directive';
import { AmountWithCurrencyPipe } from './pipes/amount-with-currency/amount-with-currency.pipe';
import { DashIfNoValuePipe } from './pipes/dash-if-no-value/dash-if-no-value.pipe';
import { DateFormatPipe } from './pipes/date-format/dateFormat.pipe';
import { IbanPipe } from './pipes/iban/iban.pipe';
import { PercentageAmountPipe } from './pipes/percentage-amount/percentage-amount.pipe';
import { TransformDatePipe } from './pipes/transform-date/transform-date.pipe';

@NgModule({
  declarations: [
    ButtonComponent,
    CardComponent,
    CardDropdownComponent,
    ModalComponent,
    LineChartComponent,
    TransactionItemComponent,
    MessageItemComponent,
    StandardAccountComponent,
    AccountBalanceDirective,
    CarouselComponent,
    BankCardComponent,
    PageLinkComponent,
    TitleArrowsComponent,
    SidebarHeaderComponent,
    FilterTransactionsComponent,
    FormFieldErrorComponent,
    ProfileItemComponent,
    TransformDatePipe,
    DateFormatPipe,
    IbanPipe,
    AmountWithCurrencyPipe,
    PercentageAmountPipe,
    DashIfNoValuePipe,
    SpinnerComponent,
    AlertComponent,
    CreditCardComponent,
    ChallengeResponseModalComponent,
    // MapComponent
    ProgressComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    RouterModule,
    NgChartsModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateService
        //useFactory: createTranslateLoader,
        //deps: [HttpClient]
      }
    })
  ],
  exports: [
    TranslateModule,
    CommonModule,
    FlexLayoutModule,
    ButtonComponent,
    CardComponent,
    ModalComponent,
    LineChartComponent,
    TransactionItemComponent,
    StandardAccountComponent,
    CarouselComponent,
    MessageItemComponent,
    BankCardComponent,
    PageLinkComponent,
    TitleArrowsComponent,
    SidebarHeaderComponent,
    FilterTransactionsComponent,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    FormFieldErrorComponent,
    ProfileItemComponent,
    AccountBalanceDirective,
    TransformDatePipe,
    DateFormatPipe,
    IbanPipe,
    AmountWithCurrencyPipe,
    PercentageAmountPipe,
    DashIfNoValuePipe,
    SpinnerComponent,
    AlertComponent,
    ChallengeResponseModalComponent,
    // MapComponent
    ProgressComponent
  ],
  providers: [DatePipe]
})
export class SharedModule {}
